import { gql } from '@apollo/client';

export const FILTERED_INSTITUTION_DASHBOARD_LAYOUTS = gql`
  query FilteredInstitutionDashboardLayouts($input: DashboardLayoutFilterArgs!) {
    layouts: filteredInstitutionDashboardLayouts(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          createdAt
          updatedAt
          name
          category
        }
      }
    }
  }
`;
